module.exports = __webpack_public_path__ + "static/card-our-zero-emissions-future-2-3045162a6a879924491bd2787dda2d3e.jpg";